'use strict';

const ManagerFlowV3 = require('../HomeyAPIV3/ManagerFlow');
const Flow = require('./ManagerFlow/Flow');
const AdvancedFlow = require('./ManagerFlow/AdvancedFlow');
const FlowCardTrigger = require('./ManagerFlow/FlowCardTrigger');
const FlowCardCondition = require('./ManagerFlow/FlowCardCondition');
const FlowCardAction = require('./ManagerFlow/FlowCardAction');

class ManagerFlow extends ManagerFlowV3 {

  static CRUD = {
    ...super.CRUD,
    Flow,
    AdvancedFlow,
    FlowCardTrigger,
    FlowCardCondition,
    FlowCardAction,
  }

  async createFlow({
    flow,
    ...props
  }) {
    return this.__super__createFlow({
      flow: Flow.transformSet(flow),
      ...props,
    });
  }

  async updateFlow({
    flow,
    ...props
  }) {
    return this.__super__updateFlow({
      flow: Flow.transformSet(flow),
      ...props,
    });
  }

  async createAdvancedFlow({
    advancedflow,
    ...props
  }) {
    return this.__super__createAdvancedFlow({
      advancedflow: AdvancedFlow.transformSet(advancedflow),
      ...props,
    });
  }

  async updateAdvancedFlow({
    advancedflow,
    ...props
  }) {
    return this.__super__updateAdvancedFlow({
      advancedflow: AdvancedFlow.transformSet(advancedflow),
      ...props,
    });
  }

  async getFlowCardTrigger({
    $cache = true,
    id,
  }) {
    if ($cache === true && this.__cache['flowcardtrigger'][id]) {
      return this.__cache['flowcardtrigger'][id];
    }

    return this.__super__getFlowCardTrigger({
      id: id.split(':').slice(3).join(':'),
      uri: id.split(':', 3).join(':'),
    });
  }

  async getFlowCardCondition({
    $cache = true,
    id,
  }) {
    if ($cache === true && this.__cache['flowcardcondition'][id]) {
      return this.__cache['flowcardcondition'][id];
    }

    return this.__super__getFlowCardCondition({
      id: id.split(':').slice(3).join(':'),
      uri: id.split(':', 3).join(':'),
    });
  }

  async runFlowCardCondition({
    id,
    ...props
  }) {
    return this.__super__runFlowCardCondition({
      id: id.split(':').slice(3).join(':'),
      uri: id.split(':', 3).join(':'),
      ...props,
    });
  }

  async getFlowCardAction({
    $cache = true,
    id,
  }) {
    if ($cache === true && this.__cache['flowcardaction'][id]) {
      return this.__cache['flowcardaction'][id];
    }

    return this.__super__getFlowCardAction({
      id: id.split(':').slice(3).join(':'),
      uri: id.split(':', 3).join(':'),
    });
  }

  async runFlowCardAction({
    id,
    ...props
  }) {
    return this.__super__runFlowCardAction({
      id: id.split(':').slice(3).join(':'),
      uri: id.split(':', 3).join(':'),
      ...props,
    });
  }

  async getFlowCardAutocomplete({
    id,
    ...props
  }) {
    return this.__super__getFlowCardAutocomplete({
      id: id.split(':').slice(3).join(':'),
      uri: id.split(':', 3).join(':'),
      ...props,
    });
  }

  async testFlow({flow, ...props}) {
    return this.__super__testFlow({
      flow: Flow.transformSet(flow),
      ...props,
    });
  }
}

module.exports = ManagerFlow;
